import { createSlice } from '@reduxjs/toolkit';
import { KegWithDetails } from '../types/KegWithDetails';


export const KegsSlice = createSlice({
    name: 'activeKeg',
    initialState: [] as KegWithDetails[],
    reducers: {
        setKegs: (state, action) => {
            state.length = 0;
            state.push(...action.payload)
            return
        },
    },
});

export const { setKegs } = KegsSlice.actions;
